import React from 'react'
import {Button, Header, Modal} from "semantic-ui-react";
import {socket} from "../../lib/socketio";
import {useSelector} from "react-redux";
import {createUserLog} from "../../lib/api";

const VSDMacro =({title, description, tagid, channel, option}) => {

    const [toggle, setToggle] = React.useState();
    const [open,setOpen]= React.useState(false);
    const ppid = useSelector(state => state.header.ppid);
    const user = useSelector(state => state.nav.user);
    const electronApp = useSelector(state => state.nav.electronApp);

    const handleOpen = () => setOpen( true);
    const handleClose = () => setOpen( false);

    const handleToggle =(event, {id}) => {
        setToggle(id);
        event.preventDefault();
        if (option === 1) {
            var vsddata = {'buttonClickType': channel, 'tags': tagid};
            socket.emit('button click', vsddata);
            setOpen(false);
        }
        else {
            var vsddata = {'buttonClickType': channel, 'tags':[tagid]};
            socket.emit('button click', vsddata);
            setOpen(false);
        }
        if (!electronApp) {
            let log = {
                user_id: user.id,
                powerplant_id: ppid,
                display_id: null,
                datetime: new Date().toISOString(),
                data: JSON.stringify({
                    tag_id: vsddata.tags,
                    type: vsddata.buttonClickType,
                }),
            };
            createUserLog({ log }).catch(console.error);
        }
    }

    return (
        <Modal trigger = {<Button>{title} </Button>}
               style = {styles.toggle}
               open = {open}
               onClose={handleClose}
               onOpen={handleOpen}>
            <Modal.Header>Confirmation</Modal.Header>
                    <Modal.Description>
                        <Header style = {styles.header}> {description}</Header>
                    </Modal.Description>
                    <Modal.Actions>
                        <Button color={'green'}
                                size='small'
                                id = '1'
                                active={toggle==='1'}
                                content='OK'
                                onClick={handleToggle}
                        />
                        <Button color={'red'}
                                size='small'
                                id = '2'
                                active={toggle==='2'}
                                content='Cancel'
                                onClick={handleClose}
                        />
                    </Modal.Actions>
        </Modal>
    );
}

const styles = {
    input: {
        padding: '15px'
    },
    toggle: {
        maxWidth: '400px',
        marginTop: '5px',
        marginBottom: '25px',
        alignItems: 'center'
    },
    header: {
        marginTop: '15px',
        marginLeft: '15px'
    }
}

export default VSDMacro;
